import { Injectable, OnDestroy } from '@angular/core';
import { BaseStoreShopsFacade } from '@city/data-access';
import { CityService } from '@city/feature';
import { CookieService } from '@core/feature';
import { MyShopFacade } from '@my-shop/data-access';
import { ProductPos } from '@product/const';
import { CustomPointOfService } from '@shop/const';
import { Observable, Subscription, of } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, skip, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MyShopService implements OnDestroy {
  shops$: Observable<CustomPointOfService[]> = this.baseStoreShopsFacade.activeBaseStoreShops$;
  activeShop$: Observable<CustomPointOfService | undefined> = this.myShopFacade.getMyShopName().pipe(
    switchMap((name) => {
      if (!name) {
        return of(undefined);
      }

      return this.shops$.pipe(
        map((shops) => (shops && shops.find((item: CustomPointOfService) => item.name === name)) || undefined),
      );
    }),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  private subscription = new Subscription();

  constructor(
    private myShopFacade: MyShopFacade,
    private cityService: CityService,
    private baseStoreShopsFacade: BaseStoreShopsFacade,
    private cookieService: CookieService,
  ) {
    this.detectChangeCity();
  }

  init(): void {
    const myShop = this.cookieService.get('myShopCookieName');
    this.setMyShop(myShop);
    this.myShopFacade.initMyShop();
  }

  isMyShopStock(arr: ProductPos[] | undefined): Observable<boolean> {
    return this.activeShop$.pipe(
      map((shop: CustomPointOfService) => {
        if (arr && shop) {
          return arr.some((item: ProductPos) => item?.name === shop?.name);
        }

        return false;
      }),
    );
  }

  setMyShop(shopId: string): void {
    this.myShopFacade.setMyShopName(shopId);
  }

  removeMyShop(): void {
    this.myShopFacade.removeMyShop();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private detectChangeCity(): void {
    this.subscription.add(
      this.cityService.activeBaseStoreCode$.pipe(distinctUntilChanged(), skip(1)).subscribe(() => {
        this.removeMyShop();
      }),
    );
  }
}
